import React from "react";

const Checkbox = ({
  checked = false,
  onChange = () => { },
  color = "#3F8CFF",
  size = 20,
  label = "",
  className = "",
  disabled = false,
}) => {
  const colorMap = {
    blue: "#3F8CFF",
    white: "#ffffff"
  };
  const bgColor = colorMap[color] || color;

  return (
    <label
      className={`inline-flex items-center gap-2 cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
    >
      <div className="relative inline-flex items-center justify-center" style={{ flexShrink: 0 }}>
        <input
          type="checkbox"
          checked={checked}
          onChange={disabled ? undefined : onChange}
          disabled={disabled}
          className="sr-only"
        />

        <div
          style={{
            width: size,
            height: size,
            minWidth: size,
            minHeight: size,
            borderRadius: Math.max(4, size * 0.15),
            border: `2px solid ${checked ? bgColor : '#cbd5e1'}`,
            background: checked ? bgColor : '#ffffff',
            transition: 'all 160ms ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg
            viewBox="0 0 24 24"
            width={Math.round(size * 0.7)}
            height={Math.round(size * 0.7)}
            fill="none"
            style={{
              opacity: checked ? 1 : 0,
              transition: 'opacity 160ms ease',
            }}
          >
            <path
              d="M4 12L10 18L20 6"
              stroke="#fff"
              strokeWidth={2.5}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      {label && (
        <span className="text-sm font-medium text-gray-700 select-none">
          {label}
        </span>
      )}
    </label>
  );
};

export default Checkbox;